<div class="line-switcher-dialog__header">
    <div class="line-switcher-dialog__header-title"><i class="line-switcher-icon sports-swap"></i>{{ title }}</div>
    @if (showCloseIcon) {
        <div class="line-switcher-dialog__header-close theme-ex" (click)="close()"></div>
    } @else {
        <div class="line-switcher-dialog__header-close" (click)="close()">
            {{ sitecore.globalMessages.Close }}
        </div>
    }
</div>
